import { inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';

import { EVENT_SOURCE_URL } from './tokens.service';

@Injectable({
  providedIn: 'root'
})
export class ImportRenewalClaimsService {
    private eventSource!: EventSource;
    private oktaAuth = inject(OKTA_AUTH);
    private baseUrl = inject(EVENT_SOURCE_URL);

    startListening(batchId: number, onProgress: (progress: any) => void, onError?: () => void) {
        const accessToken = this.oktaAuth.getAccessToken();

        this.eventSource = new EventSource(`${this.baseUrl}/renewal-claim/${batchId}/import-data?access_token=${accessToken}`);

        this.eventSource.onmessage = (event) => {
            const progress = JSON.parse(event.data);

            if (progress) {
                onProgress(progress);

                if (progress.progress === 100 || progress.message === 'Import completed.') {
                    this.stopListening();
                }
            }
        };

        this.eventSource.onerror = (error) => {
            console.error('SSE connection error');

            if (onError) {
                onError();
            }

            this.stopListening();
        };
    }

    stopListening() {
        if (this.eventSource) {
            this.eventSource.close();
        }
    }
}
